import { memo } from "react";
import { type AudienceV3 } from "features/mediaDataRoom/models";

interface DeleteAudienceV3DialogMessageProps {
  audience: AudienceV3;
}

const DeleteAudienceV3DialogMessage = memo<DeleteAudienceV3DialogMessageProps>(
  ({ audience }) => {
    if (!audience.sharedWith.length) {
      return null;
    }
    return audience.sharedWith.map(({ name }) => name).join(", ");
  }
);
DeleteAudienceV3DialogMessage.displayName = "DeleteAudienceV3DialogMessage";

export default DeleteAudienceV3DialogMessage;
